import { IconWrapper } from '../runtime';
export default IconWrapper('content-protection-area-cancel', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M4.5 1.74976H3.25C2.42157 1.74976 1.75 2.42133 1.75 3.24976V4.49976M6 1.74976H10M11.5 1.74976H12.75C13.5784 1.74976 14.25 2.42133 14.25 3.24976V4.49976M1.75 9.99976V6.01626M1.75 11.4998V12.7498C1.75 13.5782 2.42157 14.2498 3.25 14.2498H4.5",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M9.25 8.74976L10.5 9.99976M10.5 9.99976L11.75 11.2498M10.5 9.99976L11.75 8.74976M10.5 9.99976L9.25 11.2498M14.25 6.95027V10.1509C14.25 10.1509 14.25 10.1509 14.25 10.1509C14.25 10.1509 14.25 11.6509 13.25 12.6509C12.6817 13.2192 11.2886 13.7727 10.691 14.1225C10.5738 14.1912 10.4235 14.1952 10.3051 14.1286C9.68965 13.7822 8.32063 13.2215 7.75 12.6509C6.75 11.6509 6.75 10.1509 6.75 10.1509C6.75 10.1509 6.75 10.1509 6.75 10.1509V6.95027C6.75 6.79393 6.86859 6.65794 7.01878 6.6174C7.03672 6.61255 7.05583 6.61117 7.07442 6.61115C8.83318 6.60938 9.60406 6.44231 10.2973 5.91548C10.4167 5.82472 10.5834 5.82462 10.7017 5.91678C11.3772 6.44275 12.0562 6.60949 13.9255 6.61115C13.9441 6.61117 13.9633 6.61255 13.9812 6.6174C14.1314 6.65794 14.25 6.79393 14.25 6.95027Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});